//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  name: "tree",
  data(){
    return{
      thiskey: null
    }
  },
  props:{
    "tree_data":{
      type: Array,
      default: ()=>{}
    }
  },
  methods:{
    clickTree: function(key){
      if(this.thiskey === key){
        this.thiskey = null;
        return
      }
      this.thiskey = key;
    },
    tree_http: function(value){
      this.$emit("tree_http", value)
    }
  },
  mounted(){

  }
}



// WEBPACK FOOTER //
// ./src/components/public/tree.vue